import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { createSelector } from "./selector";
import { State, Selector } from "./types";
import { Boundaries } from "@planzone/core";

const initialState: State = [];

function handleRequest(
  state: State,
  { calendarHolidays }: Boundaries["editCalendarHolidays"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.calendarHolidays.uuid === calendarHolidays.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          calendarHolidays,
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  { calendarHolidays }: Boundaries["editCalendarHolidays"]["success"],
): State {
  return state.map((res) =>
    res.calendarHolidays.uuid === calendarHolidays.uuid
      ? { calendarHolidays, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { calendarHolidays }: Boundaries["editCalendarHolidays"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.calendarHolidays.uuid === calendarHolidays.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          calendarHolidays,
          request: setRequestStateToFailure(),
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editCalendarHolidaysRequested]: handleRequest,
    [events.editCalendarHolidaysSucceeded]: handleSuccess,
    [events.editCalendarHolidaysFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
